import React, {PureComponent as Component} from 'react';

import FormManager from "../../../../ui/template/Form/FormManager";
import {MCbrowser} from "../../../Context/browserContext";
import likeInsertApi from "./Api/insertLikeApi";
import PropTypes from "prop-types";
import {Heart, MessageSquare, Share2} from "react-feather";
import { digitsEnToFa } from "@persian-tools/persian-tools";

class  LikeInsert  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.handlePostUp = this.postUp.bind(this);
        this.Hclick = this.click.bind(this);
        this.state = {render:true};
        this.values = {   };

        this.numberLikes="";
        this.numberComments="";

        this.form1=React.createRef();
        this.props=props;
    };

    async click(e) {
        await this.postUp();
        e.preventDefault();
        return false;
    }

    async postUp() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await likeInsertApi(this.props.topicId );
        if(l===true){
            let page = this.context.page;
            let r="topicLike"+this.props.topicId;
            page.dispatcher.run("route",r,"inserted");
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }

    componentDidMount() {

    }

    setNumberComments(num){
        if(num>0){
            this.numberComments =  digitsEnToFa(num);
        }else{
            this.numberComments="";
        }
        this.refresh();
    }

    setNumberLikes(num){
        if(num>0){
            this.numberLikes= digitsEnToFa(num);
        }else{
            this.numberLikes="";
        }
        this.refresh();
    }


    render() {

    return (
        <React.Fragment>
            <FormManager ref={this.form1} submit={this.handlePostUp} className="d-inline-block">
                <a href="javascript: void(0)" className="mr-3 text-secondary font-10" onClick={this.Hclick}>
                    <Heart color={"red"}  className="mr-1"   size={16} />
                    {this.numberLikes}
                </a>
                <a href="javascript: void(0)" className="mr-3 text-secondary font-10">
                    <MessageSquare className="mr-1" size={16} />
                    {this.numberComments}
                </a>
            </FormManager>
        </React.Fragment>
    )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

LikeInsert.propTypes = {
    topicId:PropTypes.string,
};

LikeInsert.contextType = MCbrowser;

export default LikeInsert;
